.multi-select-box-wrapper {
  position: relative;
}

.multi-select-box-trigger {
  align-items: center;
  background-color: var(--color-uva-white);
  border: 1px solid var(--color-grey-500);
  border-radius: 0.5rem;
  cursor: pointer;
  display: flex;
  font: inherit;
  height: 2.75rem;
  justify-content: space-between;
  line-height: inherit;
  overflow: hidden;
  padding: 0.4rem 2rem 0.4rem 1rem;
  position: relative;
  width: 100%;
}

.multi-select-box-trigger--darkBorder {
  border-color: var(--color-uva-black);
}

.multi-select-box-trigger--not-valid {
  border-color: var(--color-red-600);
}

.multi-select-box-trigger:focus-visible {
  background-color: var(--color-grey-300);
  outline: 1px solid var(--color-grey-300);
}

.multi-select-box-trigger:focus-visible,
.multi-select-box-trigger:hover {
  background-color: var(--color-grey-300);
}

.multi-select-box-trigger-label {
  min-height: 0.65rem;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.multi-select-box-trigger:disabled:hover {
  background-color: var(--color-uva-white);
  cursor: not-allowed;
}

.multi-select-box-trigger-icon {
  position: absolute;
  right: 0.875rem;
}

.multi-select-box-trigger-icon--open {
  transform: rotate(180deg);
}

.multi-select-box-listbox--wrapper {
  border-radius: 0.5rem;
  box-shadow: 0 0 0.25rem 0 rgba(0 0 0 / 25%);
  display: flex;
  height: auto;
  margin: 0.25rem 0;
  overflow: hidden;
  position: fixed;
  width: auto;
  z-index: 20;
}

.multi-select-box-listbox {
  background-color: var(--color-uva-white);
  border-radius: var(--border-radius);
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  list-style: none;
  margin: 0;
  min-width: 100%;
  overflow-y: auto;
  padding: 0.25rem;
  white-space: nowrap;
  width: fit-content;
}

.multi-select-box-listbox-option {
  border-radius: 0.25rem;
  cursor: pointer;
  display: flex;
  height: 2.5rem;
  justify-content: flex-start;
  position: relative;
  user-select: none;
  width: 100%;
}

.multi-select-box-listbox-option--active,
.multi-select-box-listbox-option:hover {
  background-color: var(--color-grey-300);
  box-shadow: 0 0 0 1px var(--color-uva-white);
}

.multi-select-box-listbox-option:focus-visible,
.multi-select-box-listbox-option:hover {
  background-color: var(--color-grey-300);
}

.multi-select-box-listbox-option-content {
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 1rem;
  padding: 0.75rem;
  width: 100%;
}

.multi-select-box-listbox-option:focus-visible {
  background-color: var(--color-grey-300);
  outline: 1px solid var(--color-grey-700);
}

.multi-select-box-listbox-option--disabled {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
  user-select: none;
}
